/* eslint-disable id-blacklist */
import { FormGroup, FormControl } from '@angular/forms';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup } from '@shared-libs/interfaces';
import { IAddress } from '@shared-models/address.model';

export class AddressFormFactory {
	private static createOptionalControls(address?: IAddress): IFormGroup<Partial<IAddress>> {
		return new FormGroup({
			id: new FormControl(address?.id),
			postbox: new FormControl(address?.postbox),
			country: new FormControl(address?.country || 'BEL'),
			lat: new FormControl(address?.lat),
			long: new FormControl(address?.long),
			street: new FormControl(address?.street),
			number: new FormControl(address?.number),
			zipcode: new FormControl(address?.zipcode, SharedFormValidators.zipcode),
			city: new FormControl(address?.city),
		});
	}

	public static createAsZipRequired(address?: IAddress): IFormGroup<Partial<IAddress>> {
		const formgroup = this.createOptionalControls(address);

		formgroup.get('zipcode').addValidators(SharedFormValidators.required);

		formgroup.updateValueAndValidity();
		return formgroup;
	}

	public static createAsRequired(address?: IAddress): IFormGroup<Partial<IAddress>> {
		const formgroup = this.createOptionalControls(address);

		formgroup.get('street').addValidators(SharedFormValidators.required);
		formgroup.get('number').addValidators(SharedFormValidators.required);
		formgroup.get('zipcode').addValidators(SharedFormValidators.required);
		formgroup.get('city').addValidators(SharedFormValidators.required);

		formgroup.updateValueAndValidity();
		return formgroup;
	}

	public static createAsOptional(address?: IAddress): IFormGroup<Partial<IAddress>> {
		return this.createOptionalControls(address);
	}

	public static getValue(form: IFormGroup<IAddress>): IAddress {
		return form.value;
	}
}
